export default {
  recharge: {
    common: {
      btn_confirm: 'Confirm',

      server_err: 'server err!',
      user_not_found_message: 'User not found',
      check_produce_message: 'Please check product',

      re_captcha_message: 'Please prove the reCaptcha',

      end: ''
    },
    index: {
      uid: 'USER ID',
      uid_required_message: 'Please input uid',
      uid_message: 'Uid only number',
      uid_placeholder: 'Uid example:123234',
      uid_notice: 'Your user ID lies in the middle of the PROFILE tab in the App.',
      contact_notice: 'Click the link below to contact us on telegram or WhatsApp if you encounter any problems when purchasing diamonds.',

      end: ''
    },

    payment: {
      nickName: 'NickName',
      uid: 'User ID',
      package: 'Package',
      diamonds: 'Diamonds',
      payment: 'Payment',
      amount: 'Amount',

      btn_return: 'return',
      btn_buy: 'Buy Now',

      pay_user_info: 'thông tin người dùng',
      name: 'Họ Tên',
      phone: 'Điện thoại',
      email: 'Email',
      btn_user_info_buy: 'Mua ngay',

      end: ''
    },

    end: ''
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js